import React, { useEffect, useState } from "react";
import { DialogHeader, DialogBody } from "@material-tailwind/react";
import { useAppDispatch, useAppSelector } from "../../../../utils/redux/hooks";
import { addservices } from "../../../../utils/redux/mainSlice";
import { Dots } from "react-activity";
import { addServices } from "../../../../utils/apis/func";
import { toast } from "react-toastify";
export default function DeleteContent({ close, item }: any) {
  const dispatch = useAppDispatch();
  const services = useAppSelector((store) => store.user.services);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
  }, [item]);

  const handleDisable = async () => {
    const id = item?._id || item?.id;
    if (!id) {
      setError("Select a service to disable.");
      return;
    }
    if (isLoading) return;
    setIsLoading(true);
    setError("");
    try {
      const res: any = await addServices({
        id,
        disabled: true,
      });
      if (res?.status !== 200 && res?.status !== 201) {
        throw new Error(res?.error?.message || "Could not disable the service. Please try again.");
      }
      dispatch(addservices(services.map((service: any) =>
        (service._id || service.id) === id ? { ...service, disabled: true } : service
      )));
      toast.success("Service disabled successfully");
      close();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not disable the service. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <DialogHeader>Delete Service</DialogHeader>
      <DialogBody>
        <div className="relative p-4 w-full  max-h-full flex  flex-col">
          <div className="p-4 md:p-5 text-center mx-auto ">
            <svg
              className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 20"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
              Are you sure you want to delete Service: {item?.name} ?
            </h3>
            {error && <p role="alert" className="mb-4 text-red-700">{error}</p>}
            <button
              data-modal-hide="popup-modal"
              type="button"
              className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center me-2"
              disabled={isLoading}
              onClick={() => void handleDisable()}
            >
              Proceed
            </button>
            <button
              data-modal-hide="popup-modal"
              type="button"
              disabled={isLoading}
              className="text-gray-500 ml-4 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
              onClick={() => {
                close();
              }}
            >
              No, cancel
            </button>
            {isLoading && (
              <>
                <Dots size={40} color="var(--admin-accent)" />
              </>
            )}
          </div>
        </div>
      </DialogBody>
    </>
  );
}
